import Vue from 'vue';
import VueRouter, { Route, RouteConfig } from 'vue-router';
import { Component } from 'vue-property-decorator';
import { handle, setting, manage } from './lucky';

Vue.use(VueRouter);

const originalPush: any = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: string): Promise<Route> {
  return originalPush.call(this, location).catch((err: any) => err);
};

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/main.vue'),
    redirect: '/handle/review',
    children: [handle, setting, manage]
  }
];

const router = new VueRouter({
  routes
});

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);

router.beforeEach((to, from, next) => {
  window.document.title = to.meta?.title || 'STATEMENT-WEB';
  next();
});

export default router;
